import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from './oe-interface';

export default class OEInterfaceAdapter extends React.Component {

    constructor(props) {
        super(props);

        this.onPreConnect = this.onPreConnect.bind(this);
        this.onConnect = this.onConnect.bind(this);
        this.onRelease = this.onRelease.bind(this);  
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(this.connected && (nextProps.receiver !== this.props.receiver || nextProps.moduleId !== this.props.moduleId))  {
            this.reconnect(nextProps);
        }
        return false;
    }

    componentDidMount() {
        this.connect();
    }

    componentWillUnmount()    {
        this.release();
    }

    reconnect(props)    {
        this.release();
        this.connect(props);
    }

    connect(props) {
        if(this.connected)  return;
        props = props || this.props;
        this.oe = props.moduleId ? oeInterfaceManager.getInterface(props.moduleId) : undefined;
        if(!this.oe)    return;
        this.connected = true;
        this.receiver = props.receiver;
        if(this.receiver) this.receiver.oe = this.oe;
        this.oe.registerOnPreConnect(this.onPreConnect);
        this.oe.register(this.onConnect, this.onRelease);
        if(this.oe.isPreReady())   this.onPreConnect();
        if(this.oe.isReady() && this.oe.isOnConnectCalled())   this.onConnect();
    }

    release()   {
        if(!this.connected) return;
        this.connected = false;
        this.oe.unregisterOnPreConnect(this.onPreConnect);
        this.oe.unregister(this.onConnect, this.onRelease);
        if(this.oe.isReady())   {
            this.onRelease();
        } else {
            this.updateState();
        }
        this.receiver = undefined;
    }

    onPreConnect()  {
        if(this.receiver && typeof(this.receiver.onPreConnect) === 'function')    this.receiver.onPreConnect();
    }

    onConnect()  {
        if(!this.receiver || this.receiver.__interfaceAdapterConnected)   return;
        this.receiver.__interfaceAdapterConnected = true;
        this.updateState();
        if(this.receiver && typeof(this.receiver.onConnect) === 'function')    this.receiver.onConnect();
    }

    onRelease()    {
        if(!this.receiver || !this.receiver.__interfaceAdapterConnected)   return;

        this.receiver.__interfaceAdapterConnected = false;

        // Save the receiver here for the onRelease call bellow and note that the updateState call can lead to a release via componentWillUnmount.
        // A release call following updateState will not execute onRelease because __interfaceAdapterConnected is false already.
        // So we are making sure that the mandatory receiver.onRelease call gets executed by saving the receiver here.
        let receiver = this.receiver;

        this.updateState(true);

        if(receiver && typeof(receiver.onRelease) === 'function')   receiver.onRelease();
    }

    updateState(released)   {
        if(this.receiver && typeof(this.receiver.updateState) === 'function') this.receiver.updateState(released);
    }

    render() {
        return null;
    }
}

OEInterfaceAdapter.defaultProps = {
};

OEInterfaceAdapter.propTypes = {
    moduleId: PropTypes.string
};